export { default } from './EditProfilePage'



// WEBPACK FOOTER //
// ./src/App/EditProfilePage/index.js